// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1z7P4","select":"Header_select__3-boG","clinic":"Header_clinic__3jysS"};